import React, { useRef, useState, useEffect, useCallback } from 'react';
import {
  DateField,
  ReferenceField,
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  useListContext,
  useRefresh,
  ListContextProvider,
  Title,
  Datagrid,
} from 'react-admin';

import { Divider, Tabs, Tab, Card } from '@material-ui/core';
import AlarmAddIcon from '@material-ui/icons/AlarmAdd';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DetailsIcon from '@material-ui/icons/Details';
import { useSnackbar } from 'notistack';

import DialogoPedidoLiberacao from '../../Components/Dialogos/DialogoPedidoLiberacao';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import Textofield from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils';
import { PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR } from '../../utils/dadosTelas';
//import ActionsField from './ActionsField';
import DialogoDeletar from './DialogoDeletar';
import DialogoEstenderPrazo from './DialogoEstenderPrazo';
import AutorizadorField from './Fields/AutorizadorField';
import StatusField from './Fields/StatusField';
import Filter from './Filter';

const tabs = [
  { id: 'ativos', name: 'Ativos' },
  { id: 'inativos', name: 'Inativos' },
];
//
const MyList = ({ ...props }) => {
  const refDialogoDeleteResource = useRef(null);
  const refresh = useRefresh();
  const { enqueueSnackbar } = useSnackbar();
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const [ativos, setAtivos] = useState([]);
  const [inativos, setInativos] = useState([]);
  const refDialogoPedidoLiberacao = useRef(null);
  const refDialogoEstenderPrazo = useRef(null);
  const refDialogoDeletar = useRef(null);

  useEffect(() => {
    if (ids && ids !== filterValues.status) {
      switch (filterValues.status) {
        case STATUS_ATIVO:
          setAtivos(ids);
          break;
        case STATUS_INATIVO:
          setInativos(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.status]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          {
            ...filterValues,
            status: value === 'ativos' ? STATUS_ATIVO : STATUS_INATIVO,
          },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );
  function handleCriar() {
    if (refDialogoPedidoLiberacao.current) {
      refDialogoPedidoLiberacao.current.handleCreate();
    }
  }

  function handleClose() {
    refresh();
  }

  function handleAprovacao(dados) {
    if (refDialogoPedidoLiberacao.current) {
      refDialogoPedidoLiberacao.current.handleEdit(dados.id);
    }
  }

  function handleDetalhes(dados) {
    if (refDialogoPedidoLiberacao.current) {
      refDialogoPedidoLiberacao.current.handleEdit(dados.id);
    }
  }

  function handleEstenderPrazoPedido({ id }) {
    if (refDialogoEstenderPrazo.current) {
      refDialogoEstenderPrazo.current.handleOpen(id);
    }
  }

  function handleDeletar({ id }) {
    if (refDialogoDeletar.current) {
      refDialogoDeletar.current.handleOpen(id);
    }
  }

  return (
    <>
      <Title title="Pedidos Liberações de preço" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.status === STATUS_ATIVO ? tabs[0].id : tabs[1].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.status === STATUS_ATIVO && (
            <ListContextProvider value={{ ...listContext, ids: ativos }}>
              <Datagrid {...props}>
                <StatusField source="id" label="Status" sortable={false} />
                <TextField source="id" label="Nº Pedido" sortable={false} />
                <ReferenceField
                  label="Cliente"
                  source="cliente_id"
                  reference="clientes"
                  sortable={false}
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <Textofield
                  label="Criador"
                  source="criador.username"
                  sortable={false}
                />
                <AutorizadorField
                  label="Autorizador"
                  source="analisador"
                  sortable={false}
                />
                <DateField
                  source="data_minima"
                  label="Início"
                  showTime
                  sortable={false}
                />
                <DateField
                  source="data_maxima"
                  label="Vencimento"
                  showTime
                  sortable={false}
                />
                <ActionsField
                  source="lalala"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  /*      handleAprovacao={handleAprovacao}
                  handleDetalhes={handleDetalhes}
                  handleEstenderPrazoPedido={handleEstenderPrazoPedido}
                  handleDeletar={handleDeletar} */
                  actions={[
                    {
                      title: 'Estender Prazo por 1h',
                      icon: <AlarmAddIcon />,
                      show: (record) =>
                        record.status === STATUS_ATIVO && !record.is_utilizado,
                      onClick: (record) => handleEstenderPrazoPedido(record),
                    },
                    {
                      title: 'Aprovação',
                      icon: <CheckCircleOutlineIcon />,
                      show: (record) =>
                        record.is_analisado &&
                        !record.is_analisado_volta &&
                        !false,
                      onClick: (record) => handleAprovacao(record),
                    },
                    {
                      title: 'Detalhes',
                      icon: <DetailsIcon />,
                      show: (record) =>
                        !(
                          record.is_analisado &&
                          !record.is_analisado_volta &&
                          !false
                        ),
                      onClick: (record) => handleDetalhes(record),
                    },
                    {
                      title: 'Excluir Pedido',
                      icon: <DeleteForeverIcon />,
                      show: (record) =>
                        record.status === STATUS_ATIVO && !false,
                      onClick: (record) => handleDeletar(record),
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.status === STATUS_INATIVO && (
            <ListContextProvider value={{ ...listContext, ids: inativos }}>
              <Datagrid {...props}>
                <StatusField source="id" label="Status" sortable={false} />
                <TextField source="id" label="Nº Pedido" sortable={false} />
                <ReferenceField
                  label="Cliente"
                  source="cliente_id"
                  reference="clientes"
                  sortable={false}
                  linkType={false}
                >
                  <TextField source="nome" />
                </ReferenceField>
                <Textofield
                  label="Criador"
                  source="criador.username"
                  sortable={false}
                />
                <AutorizadorField
                  label="Autorizador"
                  source="analisador"
                  sortable={false}
                />
                <DateField
                  source="data_minima"
                  label="Início"
                  showTime
                  sortable={false}
                />
                <DateField
                  source="data_maxima"
                  label="Vencimento"
                  showTime
                  sortable={false}
                />
                <ActionsField
                  source="lalala"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  /*      handleAprovacao={handleAprovacao}
                  handleDetalhes={handleDetalhes}
                  handleEstenderPrazoPedido={handleEstenderPrazoPedido}
                  handleDeletar={() => {}}
                  disabledDeletar */
                  actions={[
                    {
                      title: 'Estender Prazo por 1h',
                      icon: <AlarmAddIcon />,
                      show: (record) =>
                        record.status === STATUS_ATIVO && !record.is_utilizado,
                      onClick: (record) => handleEstenderPrazoPedido(record),
                    },
                    {
                      title: 'Aprovação',
                      icon: <CheckCircleOutlineIcon />,
                      show: (record) =>
                        record.is_analisado &&
                        !record.is_analisado_volta &&
                        !true,
                      onClick: (record) => handleAprovacao(record),
                    },
                    {
                      title: 'Detalhes',
                      icon: <DetailsIcon />,
                      show: (record) =>
                        !(
                          record.is_analisado &&
                          !record.is_analisado_volta &&
                          !true
                        ),
                      onClick: (record) => handleDetalhes(record),
                    },
                    {
                      title: 'Excluir Pedido',
                      icon: <DeleteForeverIcon />,
                      show: (record) => record.status === STATUS_ATIVO && !true,
                      onClick: (record) => {},
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <DialogoDeletar ref={refDialogoDeleteResource} />
      <DialogoPedidoLiberacao
        ref={refDialogoPedidoLiberacao}
        handleClose={handleClose}
      />
      <DialogoEstenderPrazo
        ref={refDialogoEstenderPrazo}
        handleClose={handleClose}
      />
      <DialogoDeletar ref={refDialogoDeletar} handleClose={handleClose} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Pedidos Liberações de preço"
      filterDefaultValues={{
        /* periodo: {
          start: new Date(),
          end: new Date(),
        }, */
        status: STATUS_ATIVO,
      }}
    />
  </ProtegerPagina>
);

export default List2;
